if (typeof MainMenu === "undefined") {
  class MainMenu extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.toggles = this.querySelectorAll('.js-menu-toggle');
      this.links = this.querySelectorAll('.js-menu-link');
      this.backs = this.querySelectorAll('.js-menu-back');
      this.initEvent();
    }

    initEvent() {
      this.toggles.forEach((toggle) => {
        toggle.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.classList.toggle('--open');
        })
      })
      this.links.forEach((link) => {
        if (link.classList.contains('--has-children')) {
          link.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.toggleMenu(link);
          });
        }
      })
      this.backs.forEach((back) => {
        back.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          const link = back.closest('.--has-children').querySelector('.--open');
          this.toggleMenu(link);
        });
      })
    }

    toggleMenu(link) {
      link.classList.toggle('--open');
    }
  }

  if (!customElements.get("main-menu")) {
    customElements.define("main-menu", MainMenu);
  }
}